module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1030.d3f212d7.png";